const sectionQuestionFaqCss = `
[data-type='section-question-faq'] [data-attribute='question-faq-container'] {
  padding: 40px 0;
}

[data-type='section-question-faq'] .accordion-input {
  display: none;
}

[data-type='section-question-faq'] .close-all {
  display: none;
}

/* Accordion container */
[data-type='section-question-faq'] .accordion-container {
  background-color: #fff;
}

/* Accordion item */
[data-type='section-question-faq'] .accordion-item {
  border-bottom: 1px solid #e5e7eb;
  overflow: hidden;
  padding: 12px 0;
  margin-top: 8px;
}

[data-type='section-question-faq'] .accordion-item:hover {
  background-color: var(--faq-accordion-hover-color, #f9fafb);
}

[data-type='section-question-faq'] .accordion-item:first-child {
  margin-top: 0;
}

[data-type='section-question-faq'] .accordion-item:last-child {
  border-bottom: none;
}

/* Header accordion */
[data-type='section-question-faq'] .accordion-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 8px 24px;
  cursor: pointer;
  transition: all 0.3s ease;
  position: relative;
  border: none;
  width: 100%;
  text-align: left;
}

/* Title */
[data-type='section-question-faq'] .accordion-title {
  font-weight: bold !important;
  font-size: 18px;
  margin: 0;
  flex: 1;
}

/* Icon chevron */
[data-type='section-question-faq'] .accordion-icon {
  font-size: 10px;
  transition: transform 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  transform-origin: center;
  margin-left: 8px;
}

[data-type='section-question-faq'] .accordion-icon svg {
  width: 20px;
  height: auto;
}

/* Content accordion - mặc định ẩn */
[data-type='section-question-faq'] .accordion-content {
  max-height: 0;
  overflow: hidden;
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

[data-type='section-question-faq'] .accordion-text {
  padding: 16px 24px;
  margin: 0;
}

/* Close button - ẩn hoàn toàn nhưng vẫn có thể click */
[data-type='section-question-faq'] .close-btn {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  cursor: pointer;
  opacity: 0;
  visibility: hidden;
  z-index: 10;
  display: none;
}

/* accordion-input */
[data-type='section-question-faq'] .accordion-input:checked ~ .accordion-header .accordion-icon {
  transform: rotate(180deg);
}

/* Khi accordion mở, hiện close button ẩn để có thể click đóng */
[data-type='section-question-faq'] .accordion-input:checked ~ .accordion-header .close-btn {
  display: block;
  visibility: visible;
}

[data-type='section-question-faq'] .accordion-input:checked ~ .accordion-content {
  max-height: 300px;
  transition: max-height 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

[data-type='section-question-faq'] .wrap-question-faq .header-question-faq .title-question-faq {
  margin: 0 0 40px 0 !important;
  text-align: center;
  font-size: 28px;
  font-weight: 700 !important;
}

@container (max-width: 768px) {
  [data-type='section-question-faq'] [data-attribute='question-faq-container'] {
    padding: 16px 0;
  }

  [data-type='section-question-faq'] .accordion-header {
    padding: 8px;
  }

  [data-type='section-question-faq'] .accordion-title {
    font-size: 16px;
  }

  [data-type='section-question-faq'] .accordion-text {
    font-size: 14px;
    padding: 16px 24px;
    border-radius: 8px;
  }

  [data-type='section-question-faq'] .wrap-question-faq .header-question-faq .title-question-faq {
    font-size: 20px;
    margin: 0 0 12px 0 !important;
  }
}
`;

export default sectionQuestionFaqCss;
